import { render } from "./CharacterProficiencies.vue?vue&type=template&id=00eb4e5f&scoped=true"
import script from "./CharacterProficiencies.vue?vue&type=script&lang=js"
export * from "./CharacterProficiencies.vue?vue&type=script&lang=js"

import "./CharacterProficiencies.vue?vue&type=style&index=0&id=00eb4e5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00eb4e5f"]])

export default __exports__